import { Component, OnInit } from '@angular/core';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { AppSurvey, JoiAppData, JoiAppInfo, SurveySubmissionData } from 'globals/store/app.data';
import { mobileAppSurveysReselector } from '../mobile-store/mobile.app.reselector';
import { MobileAppSubpage } from '../mobile-store/mobile.data';
import { MobileAppActions, mobileAppFeature } from '../mobile-store/mobile.app.era';
import { SurveyComponent } from 'src/app/modules/app/survey.component';
import { IconComponent } from '../../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'mobile-app-feedback',
    template: `
<div class="feedback">
  <ng-container *ngIf="!!appInfo && !selectedSurvey">
    <h3 *ngIf="!!activeSurveys.length">PLEASE LEAVE YOUR FEEDBACK</h3>
    <div class="active-survey" *ngFor="let survey of activeSurveys" (click)="selectedSurvey = survey">
      {{ survey.title }}
    </div>
    <h3 *ngIf="!!completedSurveys.length">COMPLETED FEEDBACK</h3>
    <div class="completed-survey" *ngFor="let survey of completedSurveys">
      {{ survey.title }}
    </div>
  </ng-container>
  <ng-container *ngIf="!!appInfo && !!appData && selectedSurvey">
    <div class="back" (click)="selectedSurvey = null"><icon [icon]="'ARROW_BACK'"></icon> Back</div>
    <survey 
      [survey]="selectedSurvey"
      [disabled]="disabled"
      [appId]="appInfo.id"
      [eventId]="appInfo.eventId"
      [useNameEmail]="!!appInfo.nameAndEmail"
      [defaultName]="appData.name || ''"
      [defaultEmail]="appData.email || ''"
      (submitSurvey)="submitSurvey($event)"
    ></survey>
  </ng-container>
</div>
`,
    styleUrls: ['./mobile-app-feedback.scss'],
    standalone: true,
    imports: [SurveyComponent, IconComponent, CommonModule]
})
export class MobileAppFeedbackComponent extends MobileAppWrapper<MobileAppFeedbackComponent> {
  appInfo: JoiAppInfo
  appData: JoiAppData
  selectedSurvey: AppSurvey
  activeSurveys: AppSurvey[] = []
  completedSurveys: AppSurvey[] = []
  disabled = false
  subPages: MobileAppSubpage[] = ['feedback']
  dottedSubPages: Set<MobileAppSubpage> = new Set(['feedback'])
  icons = { feedback: 'NOTES24' }
  names = { feedback: 'Feedback' }

  constructor() {
    super()
    this.subProp(this.store.select(mobileAppFeature.selectAppInfo), 'appInfo')
    this.subProp(this.store.select(mobileAppFeature.selectAppData), 'appData')
    this.selectCallback(mobileAppSurveysReselector, null, ({ activeSurveys, completedSurveys }) => {
      this.activeSurveys = activeSurveys
      this.completedSurveys = completedSurveys
    })
  }

  async submitSurvey(submissionData: SurveySubmissionData) {
    this.disabled = true
    await this.mobileAppService.submitSurvey(submissionData)
    this.appData.completedSurveyIds.push(submissionData.surveyId)
    this.mobileAppService.saveAppData(this.appData)
    this.store.dispatch(MobileAppActions.loadAppData({payload: this.appData}))
    this.selectedSurvey = null
    this.disabled = false
  }
}

